@tailwind base;
@tailwind components;
@tailwind utilities;

:host([contained]) {
  background: inherit;
  display: block;
}


.ids-spinner {
  align-items: center;
  justify-content: center;
}

.ids-spinner.contained {
  margin: 0 auto;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: inherit;
  overflow: hidden;
}

@media screen and (prefers-reduced-motion: reduce) {
  .spinner {
    animation: none;
  }
}

@media screen and (prefers-reduced-motion: reduce) and (prefers-reduced-motion: reduce) {
  .spinner .path {
    animation: none;
  }
}

.spinner {
  animation: rotate 2s linear infinite;
  z-index: 2;
}

@media screen and (prefers-reduced-motion: reduce) {
  .spinner .path {
    animation: none;
  }
}

.spinner .path {
  animation: dash 1s ease-in-out infinite;
}

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes dash {
  0% {
    stroke-dasharray: 1, 150;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -35;
  }

  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -124;
  }
}
